import React, {Component} from 'react'
import '../styles/Admin.css'
import {Link} from "react-router-dom";

export default class SidebarAdmin extends Component {

    render() {
        return <div className="sidebarAdmin">
            <div className="linki" style={{marginTop: 10}}>
                <Link to={'/admin/panel/aktualnosci'}>
                    <div
                        className={window.location.href.indexOf('aktualnosci') > -1 ? 'menuLink menuLinkActive' : 'menuLink'}>
                        <div className="row">
                            <div className="col-4 text-right" style={{paddingRight: 0}}><i className="fa fa-newspaper-o"
                                                                                           style={{paddingRight: 5}}
                                                                                           aria-hidden="true"> </i>
                            </div>
                            <div className="col-8 text-left" style={{paddingLeft: 10}}>Aktualności</div>
                        </div>
                    </div>
                </Link>
                <Link to={'/admin/panel/eventy'}>
                    <div
                        className={window.location.href.indexOf('eventy') > -1 ? 'menuLink menuLinkActive' : 'menuLink'}>
                        <div className="row">
                            <div className="col-4 text-right" style={{paddingRight: 0}}><i className="fa fa fa-star"
                                                                                           style={{paddingRight: 5}}
                                                                                           aria-hidden="true"> </i>
                            </div>
                            <div className="col-8 text-left" style={{paddingLeft: 10}}>Eventy</div>
                        </div>
                    </div>
                </Link>
                <Link to={'/admin/panel/slider'}>
                    <div
                        className={window.location.href.indexOf('slider') > -1 ? 'menuLink menuLinkActive' : 'menuLink'}>
                        <div className="row">
                            <div className="col-4 text-right" style={{paddingRight: 0}}><i
                                className="fa fa fa-picture-o"
                                style={{paddingRight: 5}}
                                aria-hidden="true"> </i>
                            </div>
                            <div className="col-8 text-left" style={{paddingLeft: 10}}>Slider</div>
                        </div>
                    </div>
                </Link>
                <Link to={'/admin/panel/strony'}>
                    <div
                        className={window.location.href.indexOf('strony') > -1 ? 'menuLink menuLinkActive' : 'menuLink'}>
                        <div className="row">
                            <div className="col-4 text-right" style={{paddingRight: 0}}><i
                                className="fa fa fa-file-text-o"
                                style={{paddingRight: 5}}
                                aria-hidden="true"> </i>
                            </div>
                            <div className="col-8 text-left" style={{paddingLeft: 10}}>Strony</div>
                        </div>
                    </div>
                </Link>
                <Link to={'/admin/panel/pliki'}>
                    <div
                        className={window.location.href.indexOf('pliki') > -1 ? 'menuLink menuLinkActive' : 'menuLink'}>
                        <div className="row">
                            <div className="col-4 text-right" style={{paddingRight: 0}}><i className="fa fa fa-file-o"
                                                                                           style={{paddingRight: 5}}
                                                                                           aria-hidden="true"> </i>
                            </div>
                            <div className="col-8 text-left" style={{paddingLeft: 10}}>Pliki</div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/SidebarAdmin.js